import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Icon from '../../Icon/Icon.js';
import { MODAL_CATEGORY_KEY, MODAL_COMPONENT_KEY } from '../Modal.meta.js';

export default InjectedStyledComponent(Icon, MODAL_CATEGORY_KEY, MODAL_COMPONENT_KEY, ['modalOpenIcon']);
